// removed by extract-text-webpack-plugin
module.exports = {"loader":"style__loader___1KrdD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/router-wrapper/style.css
// module id = 457
// module chunks = 0